import { apiClient, orgApiPath } from '@/core/api';

export type AssetUploadTransport = 'multipart' | 'resumable';

let cachedTransport: AssetUploadTransport | null = null;

/** Parse build-time ``VITE_ASSET_UPLOAD_TRANSPORT`` (exported for unit tests). */
export function parseAssetUploadTransportFromVite(
  raw: string | undefined,
): AssetUploadTransport | null {
  const value = raw?.trim().toLowerCase();
  if (value === 'multipart' || value === 'resumable') return value;
  return null;
}

function parseViteTransport(): AssetUploadTransport | null {
  return parseAssetUploadTransportFromVite(import.meta.env?.VITE_ASSET_UPLOAD_TRANSPORT);
}

/** Clear session cache (unit tests only). */
export function resetCachedAssetUploadTransportForTests(): void {
  cachedTransport = null;
}

/**
 * Resolve upload transport: build-time ``VITE_ASSET_UPLOAD_TRANSPORT`` first,
 * else one ``GET …/upload-config`` per SPA session.
 */
export async function resolveAssetUploadTransport(): Promise<AssetUploadTransport> {
  const fromVite = parseViteTransport();
  if (fromVite) return fromVite;
  if (cachedTransport) return cachedTransport;
  const config = await apiClient<{ transport: AssetUploadTransport }>(
    orgApiPath('/assets/upload-config'),
  );
  cachedTransport = config.transport;
  return cachedTransport;
}
